"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeStorage = void 0;
var inMemoryStorage = {};

function isSupported(getStorage) {
  try {
    var key = '__some_random_key_you_are_not_going_to_use__';
    getStorage().setItem(key, key);
    getStorage().removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

var safeStorage = function safeStorage(getStorage) {
  return {
    clear: function clear() {
      if (isSupported(getStorage)) {
        getStorage().clear();
      } else {
        inMemoryStorage = {};
      }
    },
    getItem: function getItem(key) {
      var _inMemoryStorage;

      if (isSupported(getStorage)) {
        return getStorage().getItem(key);
      }

      return (_inMemoryStorage = inMemoryStorage) === null || _inMemoryStorage === void 0 ? void 0 : _inMemoryStorage[key];
    },
    removeItem: function removeItem(key) {
      if (isSupported(getStorage)) {
        getStorage().removeItem(key);
      } else {
        var _inMemoryStorage2;

        (_inMemoryStorage2 = inMemoryStorage) === null || _inMemoryStorage2 === void 0 ? true : delete _inMemoryStorage2[key];
      }
    },
    setItem: function setItem(key, value) {
      if (isSupported(getStorage)) {
        getStorage().setItem(key, value);
      } else {
        inMemoryStorage[key] = value;
      }
    }
  };
};

exports.safeStorage = safeStorage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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